'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = require('./plugin');

module.exports = function (_Plugin) {
  _inherits(Decelerate, _Plugin);
  /**
   * @private
   * @param {Viewport} parent
   * @param {object} [options]
   * @param {number} [options.friction=0.95] percent to decelerate after movement
   * @param {number} [options.bounce=0.8] percent to decelerate when past boundaries (only applicable when viewport.bounce() is active)
   * @param {number} [options.minSpeed=0.01] minimum velocity before stopping/reversing acceleration
   */


  function Decelerate(parent, options) {
    _classCallCheck(this, Decelerate);

    var _this = _possibleConstructorReturn(this, (Decelerate.__proto__ || Object.getPrototypeOf(Decelerate)).call(this, parent));

    options = options || {};
    _this.friction = options.friction || 0.95;
    _this.bounce = options.bounce || 0.5;
    _this.minSpeed = typeof options.minSpeed !== 'undefined' ? options.minSpeed : 0.01;
    _this.saved = [];

    _this.reset();

    _this.parent.on('moved', function (data) {
      return _this.moved(data);
    });

    return _this;
  }

  _createClass(Decelerate, [{
    key: 'down',
    value: function down() {
      this.saved = [];
      this.x = this.y = false;
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this.x || this.y;
    }
  }, {
    key: 'move',
    value: function move() {
      if (this.paused) {
        return;
      }

      var count = this.parent.countDownPointers();

      if (count === 1 || count > 1 && !this.parent.plugins['pinch']) {
        this.saved.push({
          x: this.parent.x,
          y: this.parent.y,
          time: performance.now()
        });

        if (this.saved.length > 60) {
          this.saved.splice(0, 30);
        }
      }
    }
  }, {
    key: 'moved',
    value: function moved(data) {
      if (this.saved.length) {
        var last = this.saved[this.saved.length - 1];

        if (data.type === 'clamp-x') {
          if (last.x === data.original.x) {
            last.x = this.parent.x;
          }
        } else if (data.type === 'clamp-y') {
          if (last.y === data.original.y) {
            last.y = this.parent.y;
          }
        }
      }
    }
  }, {
    key: 'up',
    value: function up() {
      if (this.parent.countDownPointers() === 0 && this.saved.length) {
        var now = performance.now();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.saved[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var save = _step.value;

            if (save.time >= now - 100) {
              var time = now - save.time;
              this.x = (this.parent.x - save.x) / time;
              this.y = (this.parent.y - save.y) / time;
              this.percentChangeX = this.percentChangeY = this.friction;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
    /**
     * manually activate plugin
     * @param {object} options
     * @param {number} [options.x]
     * @param {number} [options.y]
     */

  }, {
    key: 'activate',
    value: function activate(options) {
      options = options || {};

      if (typeof options.x !== 'undefined') {
        this.x = options.x;
        this.percentChangeX = this.friction;
      }

      if (typeof options.y !== 'undefined') {
        this.y = options.y;
        this.percentChangeY = this.friction;
      }
    }
  }, {
    key: 'update',
    value: function update(elapsed) {
      if (this.paused) {
        return;
      }

      var moved = void 0;

      if (this.x) {
        this.parent.x += this.x * elapsed;
        this.x *= this.percentChangeX;

        if (Math.abs(this.x) < this.minSpeed) {
          this.x = 0;
        }

        moved = true;
      }

      if (this.y) {
        this.parent.y += this.y * elapsed;
        this.y *= this.percentChangeY;

        if (Math.abs(this.y) < this.minSpeed) {
          this.y = 0;
        }

        moved = true;
      }

      if (moved) {
        this.parent.emit('moved', {
          viewport: this.parent,
          type: 'decelerate'
        });
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.x = this.y = null;
    }
  }]);

  return Decelerate;
}(Plugin);